export default {
    state: {
        filtroPesquisa: {},
        clienteFiltro: null,
        clienteNome: {},
        textoFiltro: '',
        showFilter: false,
    },
    mutations: {
        setFiltroPesquisa(state, payload) {
            state.filtroPesquisa = payload
        },
        setClienteFiltro(state, payload) {
            state.clienteFiltro = payload
        },
        setTextoFiltro(state, payload) {            
            state.textoFiltro = payload
        },
        setShowFilter(state, payload) {
            state.showFilter = payload
        }
    },
    actions: {
        setFiltroPesquisa(context, payload) {
            context.commit('setFiltroPesquisa', payload)
        },
        setClienteFiltro(context, payload) {
            context.commit('setClienteFiltro', payload)
        },
        setClienteNome(context, payload) {
            context.commit('setClienteNome', payload)
        },
        setTextoFiltro(context, payload) {            
            context.commit('setTextoFiltro', payload)
        },
        setShowFilter(context, payload) {
            context.commit('setShowFilter', payload)
        }
    },
    getters: {
        getFiltroPesquisa(state) {
            return state.filtroPesquisa
        },
        getClienteFiltro(state) {
            return state.clienteFiltro
        },
        getTextoFiltro(state) {
            return state.textoFiltro
        },
        getShowFilter(state) {
            return state.showFilter
        }
    }
}